// src/pages/Dashboard/Finance/Payroll/ProcedureReport.jsx
import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";
import { useTranslation } from "react-i18next";

const ProcedureReport = ({ procedureData = {} }) => {
  const { t } = useTranslation();
  // Assuming procedureData is an object whose keys represent categories:
  const data = Object.keys(procedureData).map((key) => ({
    name: key,
    value: Number(procedureData[key].total_amount) || 0,
  }));

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.procedureReport")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={70} outerRadius={120} paddingAngle={5}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={["#8884d8", "#82ca9d", "#ffc658", "#a4de6c"][index % 4]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend verticalAlign="bottom" />
          </PieChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default ProcedureReport;
